// Type-only so this does not create a runtime cycle with the dropdown.
import type { CopilotAction } from 'components/copilotDropdown';

import {
  copilotActionPanels,
  copilotSendFeedbackAction,
  type CopilotActionParams,
} from './copilotActions.panels';
import { type CopilotActionContext } from './copilotActions.types';
import { copilotDropdownAction } from './copilotDropdownAction';

/**
 * Builds an editor's copilot dropdown menu from its context, so availability and
 * order are stated once — in the context — rather than restated per editor.
 */
export const buildCopilotActions = (
  context: CopilotActionContext,
  params: CopilotActionParams,
): Record<string, CopilotAction> => {
  const panelArgs = {
    ...params,
    disabledImprovements: context.disabledImprovements,
  };

  // Every entry's getStatus destructures what it needs from this.
  const status = {
    channel: params.channel,
    hasStyleGuideForChannel: params.hasStyleGuideForChannel,
    hasLanguage: !!params.languageCode,
    csid: params.csid,
  };

  const entries: [string, CopilotAction][] = context.actions.map((id) => [
    id,
    copilotDropdownAction(id, {
      context,
      content: copilotActionPanels[id](panelArgs),
      status,
    }),
  ]);

  return Object.fromEntries([
    ...entries,
    ['sendFeedback', copilotSendFeedbackAction()],
  ]);
};
